<template>
    <section class="users-list">
        <div class="users-body">
            <div class="people people_pseudo" v-for="user_pseudo in 8" :key="user_pseudo">
                <div class="people-avatar"></div>
                <p class="people__name"></p>
                <p class="people__status"></p>
                <p class="people-description"></p>
                <div class="people-category" >
                    <div class="people-category__item"></div>
                    <div class="people-category__item"></div>
                    <div class="people-category__item"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default{
    name: 'UserList'
}
</script>
